<div
  [ngClass]="{
    'global-input-mat': global(),
  }"
>
  @if (!control()) {
    <mat-form-field>
      <input
        class="cursor-pointer"
        matInput
        readonly
        [matDatepicker]="pickerMat"
        [min]="minDate()"
        [max]="maxDate()"
        [(ngModel)]="selectedDate"
        [placeholder]="placeholder()"
        (click)="pickerMat.open()"
        (dateChange)="onDateChange($event)"
      />
      <button
        class="btn calendar-btn-md"
        [ngClass]="{
          'bi bi-calendar3 btn-primary': !selectedDate(),
          'bi bi-trash btn-danger': selectedDate(),
        }"
        (click)="onButtonClick()"
        [attr.aria-label]="selectedDate() ? 'Clear date' : 'Open date picker'"
      ></button>
      <mat-datepicker
        #pickerMat
        [panelClass]="panelClass()"
        [startView]="startView()"
        [startAt]="startAt()"
      ></mat-datepicker>
    </mat-form-field>
  }

  @if (control()) {
    <mat-form-field>
      <input
        class="cursor-pointer"
        matInput
        readonly
        [matDatepicker]="pickerMat"
        [min]="minDate()"
        [max]="maxDate()"
        [formControl]="formControl"
        [placeholder]="placeholder()"
        (click)="pickerMat.open()"
        (dateChange)="onDateChange($event)"
      />
      <button
        class="btn calendar-btn-m"
        type="button"
        [disabled]="formControl.disabled"
        [ngClass]="{
          'bi bi-calendar3 btn-primary': !formControl.value,
          'bi bi-trash btn-danger': formControl.value,
        }"
        (click)="onButtonClickWithControl()"
        [attr.aria-label]="
          formControl.value ? 'Clear date' : 'Open date picker'
        "
      ></button>
      <mat-datepicker
        #pickerMat
        [panelClass]="panelClass()"
        [startView]="startView()"
        [startAt]="startAt()"
      ></mat-datepicker>
    </mat-form-field>
  }
</div>
@if (control() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
